import { Navigate } from 'react-router-dom';

export const DedicatedWritingCatchall = () => {
  return <Navigate replace to="/a/" />;
};
